import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { useMemo, useContext, createContext } from 'react';
import { bindActionCreators } from 'redux';
import { getToken, handleCallback, login, logout } from '../redux/actions/auth';
export var ChordAuthClientContext = createContext(null);
ChordAuthClientContext.displayName = 'ChordAuthClientContext';
/**
 * The `useAuth` hook returns information about the current authentication
 * session, and functions for logging in and logging out. Chord's preferred
 * authentication provider is [Magic](https://magic.link/) through our
 * [chord-magic package](https://github.com/chordcommerce/chord-ui/pkgs/npm/chord-magic).
 *
 * @example
 *
 * ```javascript
 * import { useAuth } from '@chordcommerce/react-autonomy'
 *
 * const AccountPage = () => {
 *   const { isLoggedIn } = useAuth()
 *   if (!isLoggedIn) return
 *
 *   // return account page
 * }
 * ```
 *
 * @category Hook
 */
export function useAuth() {
  var authState = useSelector(function (state) {
    return state.auth;
  }, shallowEqual);
  var authClient = useContext(ChordAuthClientContext);
  var dispatch = useDispatch();
  var hooks = useMemo(function () {
    return _objectSpread({
      serviceClient: authClient.getServiceClient()
    }, bindActionCreators({
      getToken: getToken,
      handleCallback: handleCallback,
      login: login,
      logout: logout
    }, dispatch));
  }, [dispatch, authClient]);
  return _objectSpread(_objectSpread({}, hooks), authState);
}